<template>
  <div class="productItem">
    <div class="productItem__thumbnail">
      <img :src="item.thumbnail"
           :alt="item.label"/>
    </div>
    <div class="productItem__content">
      <h5 class="productItem__title">{{item.label}}</h5>
      <div class="productItem__closeUp">
        <span>Configure</span>
      </div>
    </div>
    <div v-if="item.switchable"
         class="productItem__switch">
      <input type="checkbox"
             :id="item.close_up.target_id"
             :name="item.close_up.target_id"
             @change="alertParent" />
      <label :for="item.close_up.target_id"></label>
    </div>
  </div>
</template>

<script>
  export default{
    props: ['info'],
    data(){
      return {
        item: this.info
      }
    },
    methods: {
      alertParent(evt){
        var vm = this;
        var isChecked = evt.target.checked;
        if (isChecked) {
          vm.$emit('increment-count');
        }
        else {
          vm.$emit('decrement-count');
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/interactive/ProductListingItem.vue